import { apiClient } from './apiClient';

export interface Business {
    id: string;
    name: string;
    tenantId: string;
}

export interface BusinessRole {
    id: string;
    name: string;
    description: string;
    isBusinessAdmin: boolean;
}

export interface CreateBusinessRoleDto {
    name: string;
    description: string;
    isBusinessAdmin: boolean;
}

export interface UpdateBusinessRoleDto {
    name: string;
    description: string;
    isBusinessAdmin: boolean;
}

export interface DeleteBusinessRoleDto {
    newRoleId?: number;
}

class BusinessRoleService {
    async getBusinesses(): Promise<Business[]> {
        try {
            const response = await apiClient.get<Business[]>('/business/list');
            return response.data;
        } catch (error) {
            console.error('Error fetching businesses:', error);
            throw error;
        }
    }

    async getBusinessRoles(businessId?: string): Promise<BusinessRole[]> {
        try {
            const url = businessId ? `/business/roles?businessId=${businessId}` : '/business/roles';
            const response = await apiClient.get<BusinessRole[]>(url);
            return response.data;
        } catch (error) {
            console.error('Error fetching business roles:', error);
            throw error;
        }
    }

    async createBusinessRole(role: CreateBusinessRoleDto, businessId?: string): Promise<BusinessRole> {
        try {
            const url = businessId ? `/business/roles?businessId=${businessId}` : '/business/roles';
            const response = await apiClient.post<BusinessRole>(url, role);
            return response.data;
        } catch (error) {
            console.error('Error creating business role:', error);
            throw error;
        }
    }

    async updateBusinessRole(roleId: string, role: CreateBusinessRoleDto, businessId?: string): Promise<BusinessRole> {
        try {
            const url = businessId 
                ? `/business/roles/${roleId}?businessId=${businessId}` 
                : `/business/roles/${roleId}`;
            const response = await apiClient.put<BusinessRole>(url, role);
            return response.data;
        } catch (error) {
            console.error('Error updating business role:', error);
            throw error;
        }
    }

    async deleteBusinessRole(roleId: string, businessId?: string): Promise<void> {
        try {
            const url = businessId 
                ? `/business/roles/${roleId}?businessId=${businessId}` 
                : `/business/roles/${roleId}`;
            await apiClient.delete(url);
        } catch (error) {
            console.error('Error deleting business role:', error);
            throw error;
        }
    }
}

export const businessRoleService = new BusinessRoleService(); 